export const companies = [
    { name: 'Tesla', state: 'California', zipCode: '94304', industry: 'Automotive' },
    { name: 'Nissan', state: 'New York', zipCode: '10001', industry: 'Automotive' },
    { name: 'Toyota', state: 'Texas', zipCode: '75001', industry: 'Automotive' },
    { name: 'Ford', state: 'California', zipCode: '94105', industry: 'Automotive' },
    { name: 'BMW', state: 'New York', zipCode: '10017', industry: 'Automotive' },
    { name: 'Mercedes', state: 'Texas', zipCode: '77001', industry: 'Automotive' },
    { name: 'Audi', state: 'California', zipCode: '90210', industry: 'Automotive' },
    { name: 'Chevrolet', state: 'New York', zipCode: '10019', industry: 'Automotive' },
    { name: 'Honda', state: 'Texas', zipCode: '78701', industry: 'Automotive' },
    { name: 'Hyundai', state: 'California', zipCode: '94111', industry: 'Automotive' },
    { name: 'Microsoft', state: 'Washington', zipCode: '98052', industry: 'Tech' },
    { name: 'Google', state: 'California', zipCode: '94043', industry: 'Tech' },
    { name: 'Acquia', state: 'Massachusetts', zipCode: '02210', industry: 'Tech' },
    { name: 'Alegeus', state: 'Massachusetts', zipCode: '02116', industry: 'Healthcare' },
    { name: 'Pfizer', state: 'New York', zipCode: '10017', industry: 'Healthcare' },
    { name: 'Johnson & Johnson', state: 'New Jersey', zipCode: '08933', industry: 'Healthcare' },
    { name: 'Applause', state: 'Massachusetts', zipCode: '02451', industry: 'Tech' },
    { name: 'Better Cloud', state: 'New York', zipCode: '10013', industry: 'Tech' },
    { name: 'Blueconic', state: 'Massachusetts', zipCode: '02109', industry: 'Tech' },
    { name: 'Comply', state: 'New York', zipCode: '10012', industry: 'Tech' },
    { name: 'Dispatch', state: 'Massachusetts', zipCode: '02110', industry: 'Tech' },
    { name: 'Duck Creek Technologies', state: 'Massachusetts', zipCode: '02210', industry: 'Tech' },
    { name: 'Icims', state: 'New Jersey', zipCode: '08540', industry: 'Tech' },
    { name: 'Ias', state: 'New York', zipCode: '10016', industry: 'Tech' },
    { name: 'Invoice Cloud', state: 'Massachusetts', zipCode: '02111', industry: 'Tech' },
    { name: 'Jebbit', state: 'Massachusetts', zipCode: '02116', industry: 'Tech' },
    { name: 'Mabl', state: 'Massachusetts', zipCode: '02210', industry: 'Tech' },
    { name: 'Quickbase', state: 'Massachusetts', zipCode: '02110', industry: 'Tech' },
    { name: 'Smartbear', state: 'Massachusetts', zipCode: '02210', industry: 'Tech' },
    { name: 'Sonatype', state: 'Maryland', zipCode: '20850', industry: 'Tech' },
    { name: 'TigerConnect', state: 'California', zipCode: '90401', industry: 'Healthcare' },
    { name: 'TRG Screen', state: 'New York', zipCode: '10004', industry: 'Tech' },
    { name: 'Triple lift', state: 'New York', zipCode: '10010', industry: 'Tech' },
    { name: 'Tripleseat', state: 'New York', zipCode: '10011', industry: 'Tech' },
    { name: 'Campion And Company', state: 'New York', zipCode: '10022', industry: 'Real Estate' },
    { name: 'Red Tree', state: 'Massachusetts', zipCode: '02108', industry: 'Real Estate' },
    { name: 'Zillow', state: 'New Jersey', zipCode: '07302', industry: 'Real Estate' },
    { name: 'Esquire Moving Inc.', state: 'California', zipCode: '94105', industry: 'Real Estate' },
    { name: 'Cabot And Company', state: 'New York', zipCode: '10036', industry: 'Real Estate' },
];

export const occupations = [
    { name: 'Sales' },
];

export const skills = {
    Tesla: {
        sales: ['Sales Pitching', 'Product Knowledge', 'Closing Skills'],
        soft: ['Problem Solving', 'Critical Thinking', 'Clear Communication']
    },
    Nissan: {
        sales: ['Prospecting', 'Negotiation', 'Storytelling'],
        soft: ['Relationship Building', 'Empathy', 'Resilience']
    },
    Toyota: {
        sales: ['Time Management', 'Confidence', 'Growth Mindset'],
        soft: ['Curiosity', 'Discipline', 'Humility']
    },
    Ford: {
        sales: ['Customer Engagement', 'Sales Strategy', 'Market Analysis'],
        soft: ['Leadership', 'Collaboration', 'Adaptability']
    },
    BMW: {
        sales: ['Brand Promotion', 'Lead Conversion', 'Customer Retention'],
        soft: ['Creativity', 'Strategic Thinking', 'Persuasion']
    },
    Mercedes: {
        sales: ['Luxury Sales', 'Client Management', 'Sales Forecasting'],
        soft: ['Professionalism', 'Attention to Detail', 'Customer Focus']
    },
    Audi: {
        sales: ['Performance Sales', 'Product Customization', 'Client Communication'],
        soft: ['Innovation', 'Teamwork', 'Empathy']
    },
    Chevrolet: {
        sales: ['Volume Sales', 'Dealer Relations', 'Inventory Management'],
        soft: ['Resilience', 'Interpersonal Skills', 'Motivation']
    },
    Honda: {
        sales: ['Retail Sales', 'Customer Service', 'Sales Analysis'],
        soft: ['Reliability', 'Patience', 'Problem Solving']
    },
    Hyundai: {
        sales: ['Fleet Sales', 'Warranty Management', 'Product Training'],
        soft: ['Efficiency', 'Technical Aptitude', 'Customer Orientation']
    },
    Microsoft: {
        sales: ['Technical Sales', 'Solution Selling', 'Account Management'],
        soft: ['Creativity', 'Teamwork', 'Adaptability']
    },
    Google: {
        sales: ['Digital Marketing', 'Ad Sales', 'Client Engagement'],
        soft: ['Innovative Thinking', 'Collaboration', 'Time Management']
    },
    'Goldman Sachs': {
        sales: ['Investment Sales', 'Portfolio Management', 'Client Relations'],
        soft: ['Analytical Thinking', 'Integrity', 'Professionalism']
    },
    'JPMorgan Chase': {
        sales: ['Wealth Management', 'Financial Advisory', 'Client Acquisition'],
        soft: ['Trustworthiness', 'Strategic Thinking', 'Customer Focus']
    },
    Pfizer: {
        sales: ['Pharmaceutical Sales', 'Medical Liaison', 'Territory Management'],
        soft: ['Empathy', 'Communication Skills', 'Ethical Judgment']
    },
    'Johnson & Johnson': {
        sales: ['Medical Device Sales', 'Product Launches', 'Client Support'],
        soft: ['Resilience', 'Interpersonal Skills', 'Motivation']
    },
    Bechtel: {
        sales: ['Project Sales', 'Construction Management', 'Client Development'],
        soft: ['Leadership', 'Negotiation', 'Problem Solving']
    },
    Fluor: {
        sales: ['Engineering Sales', 'Client Solutions', 'Proposal Management'],
        soft: ['Attention to Detail', 'Time Management', 'Customer Service']
    }
};

export const experiences = [
    {
        title: "Introducing yourself",
        description: "Train to sell with this ready to use life-like simulation",
        duration: "3 min. experience",
    },
    {
        title: "Pitching",
        description: "Practice a classic cold call with this ready to use life-like simulation",
        duration: "3 min. experience",
    },
    {
        title: "Objection handling",
        description: "Practice objection handling with this ready to use life-like simulation",
        duration: "3 min. experience",
    },
    {
        title: "Probing & discovery",
        description: "Practice an initial sales conversation with this easy to build personalized simulation",
        duration: "5 min. experience",
    },
    {
        title: "Asking for referrals/networking",
        description: "Practice pitching your product with this easy to build personalized simulation",
        duration: "5 min. experience",
    },
    {
        title: "Setting up next steps/meetings",
        description: "Practice objection handling with this easy to build personalized simulation",
        duration: "5 min. experience",
    },
    {
        title: "Asking for the business",
        description: "Practice objection handling with this easy to build personalized simulation",
        duration: "5 min. experience",
    },
    {
        title: "Interpersonal skills",
        description: "Practice objection handling with this easy to build personalized simulation",
        duration: "5 min. experience",
    }
];